import { ColDef } from 'ag-grid-community';
import { ExternalPriceDto, PriceChangeDirection } from '../../common/PricePrgClient';

export type ExternalPriceRow = {
    [externalPricelistId: number]: number;
    productId: number;
    productExtRef: string;
    productName: string;
    unit: string;
    country: string;
    inPrices: { [pricelistId: number]: number };
    priceChangeDirections: {
        external: { [pricelistId: number]: PriceChangeDirection };
        in: { [externalPricelistId: number]: PriceChangeDirection };
    };
    updatedBys: {
        externalPrices: { [externalPricelistId: number]: string };
        inPrices: { [pricelistId: number]: string };
    };
    updatedDates: {
        externalPrices: { [externalPricelistId: number]: string };
        inPrices: { [pricelistId: number]: string };
    };
    comments: {
        [externalPricelistId: number]: string;
    };
    discounts: {
        [externalPricelistId: number]: number;
    };
    externalPriceIds: {
        [externalPricelistId: number]: number;
    };
    saves: {
        [externalPricelistId: number]: number;
    };
    agreementPriceIds: number[];
    appliedCalculations: number[];
};

export type ExternalPrice = ExternalPriceDto & {
    priceToBeSaved?: number;
};
export const externalPriceInitialColDefs: ColDef<ExternalPriceRow>[] = [
    {
        field: 'productId',
        headerName: 'Product id',
        width: 100
    },
    {
        field: 'productName',
        headerName: 'Product name',
        width: 300
    },
    {
        field: 'country',
        headerName: 'Country',
        width: 82
    },
    {
        field: 'unit',
        headerName: 'Unit',
        width: 60
    }
];
